if (typeof G == 'undefined') G = {};

G.Board = function (lvl, tilesize, editor) {

  Phaser.Group.call(this, game);
  this.state = game.state.getCurrentState();

  this.lvl = lvl;

  // signals
  this.onBoardDeconstructed = new Phaser.Signal();
  this.onActionQueueEmpty = new Phaser.Signal();

  this.MAX_NUMBER_OF_REGULAR_CANDY = lvl.nrOfTypes;
  this.collectCells = lvl.collectCells || false;

  this.tilesize = tilesize;
  this.offsetX = 0;
  this.offsetY = 0;
  this.editorMode = editor;

  this.borderSize = G.l(8);

  this.tweenObj = { a: 0.6 };
  game.add.tween(this.tweenObj).to({ a: 1 }, 500, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);

  this.levelData = new G.GridArray(lvl.levelData);
  this.boardData = new G.GridArray(this.levelData.width, this.levelData.height);

  this.checkMatchList = [];
  this.checkSpecialMatchList = [];
  this.checkAfterFall = [];
  this.fallCheckList = [];

  this.duringAnimation = 0;
  this.duringFall = 0;
  G.sb("onCandyFallStart").add(function () { this.duringFall++ }, this);
  G.sb("onCandyFallFinish").add(function (candy) {
    this.duringFall--
    if (this.fallCheckList.indexOf(candy) == -1) this.fallCheckList.push(candy);
    /*if (this.matcher.quickMatchCheck(candy)) {

      console.log(candy);
      this.checkMatchList.push(candy);
    }*/
  }, this);
  G.sb("onCandyAnimationStart").add(function () { this.duringAnimation++ }, this);
  G.sb("onCandyAnimationFinish").add(function () { this.duringAnimation-- }, this);
  G.sb("onScreenResize").add(this.onResize, this);


  this.matcher = new G.BoardMatcher(this);

  this.boardBackground = new G.BoardBackground(this);

  this.background = game.make.image(0, 0, this.boardBackground.renderTexture);
  /*this.background.width = this.levelData.width*tilesize;
  this.background.height = this.levelData.height*tilesize;
  */
  this.background.x = -this.tilesize;
  this.background.y = -this.tilesize;
  //this.background.width += this.borderSize;
  //this.background.height += this.borderSize;
  this.add(this.background);


  this.tileShade = G.makeImage(0, 0, 'tile_shade', 0.5, this);
  this.tileShade.visible = false;
  this.selectShade = G.makeImage(0, 0, 'tile_shade', 0.5, this);
  this.selectShade.visible = false;

  this.boardDirt = new G.BoardDirt(this);
  this.boardDirtS = new G.BoardDirtS(this);

  this.candySelection = new G.CandySelection(this);

  this.boardCandies = new G.BoardCandies(
    this,
    this.boardData,
    lvl,
    lvl.nrOfTypes,
    this.editorMode);

  this.boardCollectCells = new G.BoardCollectCells(this, lvl);
  this.boardCollectCells.pivot.y = 2;
  game.add.tween(this.boardCollectCells.pivot)
    .to({ y: -4 }, 600, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);

  this.boardJam = new G.BoardJam(this);
  this.boardIce = new G.BoardIce(this);
  this.boardIce.alpha = 0.8;
  this.boardCage = new G.BoardConcrete(this);

  this.boardCandies.secondFloor.parent.bringToTop(this.boardCandies.secondFloor);
  this.boardCandies.fxGroup.parent.bringToTop(this.boardCandies.fxGroup);
  this.boardCandies.boosterFxGroup.parent.bringToTop(this.boardCandies.boosterFxGroup);
  this.boardCandies.thirdFloor.parent.bringToTop(this.boardCandies.thirdFloor);
  this.boardCandies.fxTopGroup.parent.bringToTop(this.boardCandies.fxTopGroup);

  this.layers = [
    this.boardDirt,
    this.boardDirtS,
    this.boardCandies,
    this.boardJam,
    this.boardCage,
    this.boardIce
  ];

  this.layersNoCandies = [
    this.boardDirt,
    this.boardDirtS,
    this.boardJam,
    this.boardCage,
    this.boardIce,
  ];

  this.inputController = new G.InputController(this);
  this.actionManager = new G.BoardActionManager(this);
  this.actionManager.onActionQueueEmpty.add(function () {
    this.onActionQueueEmpty.dispatch();
  }, this);

  this.refiller = new G.Refiller(lvl, this.boardCandies);
  this.fallMgr = new G.BoardFallMgr(this, this.refiller);

  this.import(this.levelData);

  this.boardBackground.redraw();

  this.lastRowInCollumn = this.getLastRowInCollumn();

  // start of Events flags
  this.fortuneCookie = { collected: false, icon: null, isSeen: false, spawned: false };
  // end of Event Flags

  this.onResize();

};


G.Board.prototype = Object.create(Phaser.Group.prototype);

G.Board.prototype.getAllTokensInCell = function (cellX, cellY) {
  var tokens = [];
  for (var i = this.layers.length; i--;) {
    var token = this.layers[i].getToken(cellX, cellY);
    if (token) tokens.push(token);
  }
  return tokens;
};

G.Board.prototype.getLastRowInCollumn = function () {

  var result = [];

  for (var i = 0; i < this.boardData.width; i++) {
    result.push(this.getLastCellInCollumn(i));
  }

  return result;

};


G.Board.prototype.pushToFallCheckList = function (candy) {

  if (candy === false) return;

  if (this.fallCheckList.indexOf(candy) == -1) this.fallCheckList.push(candy);
}

G.Board.prototype.onResize = function () {
  this.center();
};


G.Board.prototype.clearBoard = function () {
  this.layers.forEach(function (layer) {
    if (layer.clearLayer) layer.clearLayer();
  });
  this.boardCollectCells.removeAllCollectCells();
};

G.Board.prototype.center = function () {
  var pxWidth = this.tilesize * this.boardData.width;
  var pxHeight = this.tilesize * this.boardData.height;
  var scaleX = Math.min(1, 640 / pxWidth);
  var scaleY = Math.min(1, (game.height - 220 - 150) / pxHeight);
  var scale = Math.min(scaleX, scaleY);

  this.scale.setTo(scale);
  this.x = G.l(320) - (pxWidth * scale) * 0.5;
  this.y = G.l(220) + (game.height - 220 - 150 - (pxHeight * scale)) * 0.5;
};

G.Board.prototype.update = function () {

  this.actionManager.update();
  // this.checkGoalCandy();

};

G.Board.prototype.isIdle = function () {
  return this.actionManager.actionList.length === 0;
};

G.Board.prototype.checkGoalCandy = function () {

  // if (this.actionManager.actionList.length > 0) return;

  var removed = false;

  for (var i = 0; i < this.boardData.width; i++) {

    var candy = this.getCandy(i, this.lastRowInCollumn[i]);

    if (candy && (candy.isGoalCandy() || candy.isBurntCandy())) {
      //it is goalCandy

      var viableToRemove = true;

      if (this.collectCells) {
        if (!this.isCandyOnCollectCell(candy)) {
          viableToRemove = false;
        }
      }

      if (viableToRemove) {
        this.boardCandies.removeCandy(i, this.lastRowInCollumn[i]);
        G.sfx.xylophone_positive6.play();
        removed = true;
      }

    }

  }


  if (removed) {
    this.actionManager.newAction('processFall');
    return true;
  }

};

G.Board.prototype.isCandyOnCollectCell = function (candy) {
  if (this.collectCells) {
    var matchingCP = this.boardCollectCells.getCollectCell(candy.cellX, candy.cellY);

    if (matchingCP) {
      return true;
    }
  }
  return false;
};

G.Board.prototype.makeMove = function (candy1, candy2, force) {

  this.actionManager.newAction('move', candy1, candy2, force);

};

G.Board.prototype.hitCell = function (cellX, cellY) {
  for (var i = this.layers.length; i--;) {
    if (!this.layers[i].onHit(cellX, cellY)) {
      //stopped propagation
      return;
    }
  }
};

G.Board.prototype.useBoosterOnCell = function (cellX, cellY) {
  for (var i = this.layers.length; i--;) {
    if (!this.layers[i].onBooster(cellX, cellY)) {
      //stopped propagation
      return;
    }
  }
};

G.Board.prototype.isMoveable = function (x, y, noCandy) {

  if (typeof x != 'number') {
    y = x[1];
    x = x[0];
  }

  if (!this.isCellOnBoard(x, y)) return false;
  if (this.isMoveBlocked(x, y)) return false;

  var candy = this.getCandy(x, y);
  if (!candy) return false;
  //if (candy.infected) return false;

  return true;
};

G.Board.prototype.isAnyInBoard = function (specificType) {
  /**
   * Please refer to EditorGoalPanel.goals for things to look for
   */
  let result = false;
  let regex;
  switch (specificType) {
    case 'dirtS': result = this.boardDirtS.getAll().length > 0; break;
    case 'ice': result = this.boardIce.getAll().length > 0; break;
    case 'concrete': result = this.boardCage.getAll().length > 0; break;
    case 'dirt': result = this.boardDirt.getAll().length > 0; break;
    case 'goalCandy':
      _.forEach(this.boardCandies.getAllCandies(), (candy) => {
        if (candy.isGoalCandy()) {
          result = true;
          return false;
        }
      });
      break;
    case 'jam': return this.boardJam.getAll().length > 0;
    case 'lc':
      result = this.boardCandies.countEditorSymbolOccurrence('lc') > 0;
      break;
    case 'chain':
      result = this.boardCandies.countEditorSymbolOccurrence('W') > 0;
      break;
    case 'burnt':
      _.forEach(this.boardCandies.getAllCandies(), (candy) => {
        if (candy.isBurntCandy()) {
          result = true;
          return false;
        }
      });
      break;
    case 'fortune':
      result = this.boardCandies.countEditorSymbolOccurrence('fortune') > 0;
      break;
  }
  return result;
}

G.Board.prototype.isMoveBlocked = function (cellX, cellY) {
  for (var i = this.layers.length; i--;) {
    if (this.layers[i].isMoveBlocked(cellX, cellY)) return true;
  }
  return false;
};

G.Board.prototype.isBoosterChangeBlocked = function (cellX, cellY) {
  for (var i = this.layers.length; i--;) {
    if (this.layers[i].isBoosterChangeBlocked(cellX, cellY)) return true;
  }
  return false;
};

G.Board.prototype.isMatchBlocked = function (cellX, cellY) {
  for (var i = this.layers.length; i--;) {
    if (this.layers[i].isMatchBlocked(cellX, cellY)) return true;
  }
  return false;
};


// for handling changes inside blockers
G.Board.prototype.matchCellExceptCandy = function (cellX, cellY) {
  for (var i = this.layersNoCandies.length; i--;) {
    if (!this.layersNoCandies[i].onMatch(cellX, cellY)) {
      //stopped propagation
      return;
    }
  }
};

G.Board.prototype.getLastCellInCollumn = function (cellX) {

  for (var i = this.boardData.height - 1; i >= 0; i--) {

    if (this.isCellOnBoard(cellX, i)) return i;

  };

};

G.Board.prototype.matchCell = function (cellX, cellY, delay, moveCellX, moveCellY) {
  for (var i = this.layers.length; i--;) {
    if (!this.layers[i].onMatch(cellX, cellY, delay, moveCellX, moveCellY)) {
      // console.log("** stopped propagation");
      //stopped propagation
      return;
    }
  }
};

G.Board.prototype.isCellInBoardArea = function (cellX, cellY) {
  return cellX < this.boardData.width && cellX >= 0 && cellY >= 0 && cellY < this.boardData.height;

};

G.Board.prototype.isCellMatchable = function (x, y, optCandy) {
  if (typeof x != 'number') {
    y = x[1];
    x = x[0];
  }

  if (!this.isCellOnBoard(x, y)) return false;
  if (this.boardIce.isToken(x, y)) return false;

  if (this.isMatchBlocked(x, y)) {
    return false;
  }

  if (optCandy) {
    return this.getCandy(x, y).isMatchableWith(optCandy);
  } else {
    return true;
  }

};


G.Board.prototype.isCellOnBoard = function (x, y) {

  if (typeof x == 'boolean') return false;

  if (typeof x != 'number') {
    y = x[1];
    x = x[0];
  }
  if (x < 0 || x >= this.boardData.width || y < 0 || y >= this.boardData.height) return false;
  return this.boardData.get(x, y) != 'X';
};

G.Board.prototype.getCandy = function (cellX, cellY) {

  if (typeof cellX != 'number') {
    return this.boardCandies.getCandy(cellX[0], cellX[1]);
  }

  return this.boardCandies.getCandy(cellX, cellY);
};

G.Board.prototype.cellToPxOut = function (cell) {

  var tilesize = this.tilesize * this.scale.x;

  return [
    this.x + this.offsetX + (tilesize * (cell[0])) + (tilesize * 0.5),
    this.y + this.offsetY + (tilesize * (cell[1])) + (tilesize * 0.5)
  ]

};

G.Board.prototype.pxInToCellX = function (px) {
  return Math.floor(px / this.tilesize);
};

G.Board.prototype.pxInToCellY = function (px) {
  return Math.floor(px / this.tilesize);
};

G.Board.prototype.cellXToPxIn = function (cellX) {
  return cellX * this.tilesize + (this.tilesize * 0.5)
};

G.Board.prototype.cellYToPxIn = function (cellY) {
  return cellY * this.tilesize + (this.tilesize * 0.5)
};

G.Board.prototype.cellToPxIn = function (cell) {
  return [
    this.cellXToPxIn(cell[0]),
    this.cellYToPxIn(cell[1])
  ]

};

G.Board.prototype.swapCandies = function (c1, c2) {
  this.boardCandies.swapCandies(c1, c2);
};

G.Board.prototype.removeCandy = function () {
  this.boardCandies.removeCandy.apply(this.boardCandies, arguments);
};

G.Board.prototype.newFallingCandy = function (cellX, cellY, type, fromCellY) {

  var newCandy = this.boardCandies.newCandy(cellX, cellY, type);
  newCandy.y = this.cellYToPxIn(fromCellY);
  newCandy.fallTo(cellX, cellY);
  newCandy.alpha = 0;

};

G.Board.prototype.export = function () {
  var result = new G.GridArray(this.boardData.width, this.boardData.height);
  result.loop(function (elem, x, y, data) {
    var cell = [];
    if (this.boardData.get(x, y) == 'X') {
      cell.push('X');
    }
    this.layers.forEach(function (layer) {
      var exp = layer.export(x, y);
      if (exp) cell.push(exp);
    });
    data[x][y] = cell;
  }, this);

  return JSON.stringify(result.data);
};

G.Board.prototype.import = function (levelData) {
  levelData.loop(function (elem, x, y) {

    for (var i = 0, len = elem.length; i < len; i++) {
      elem[i] = elem[i].toString();

      //old version
      if (elem[i][0] == 'W') {
        elem[i] = elem[i][1] + ':' + elem[i][0];
      }

      if (elem[i] == 'X') {
        this.boardData.set(x, y, 'X');
      } else {
        var imported = false;
        this.layersNoCandies.forEach(function (layer) {
          var imp = layer.import(x, y, elem[i]);
          if (!imported && imp) imported = true;
        });
        if (!imported) {
          this.boardCandies.import(x, y, elem[i]);
        }
      }

    };
  }, this);

  if (!this.editorMode) {
    this.boardCandies.replaceRandomCandies();
    if (this.matcher.checkPossibleMoves().length == 0) {
      this.shuffleCandies(true);
    }
  }

  this.possibleMoves = this.matcher.checkPossibleMoves();

};

G.Board.prototype.shuffleCandies = function (immediate) {
  var self = this;

  var attempts = 0;
  var candiesToShuffle = getCandiesToShuffle();
  ensureMatchIsPossible(candiesToShuffle);

  do {
    attempts++;
    if (attempts > 60) {
      G.Utils.SentryLog.logError(
        "Failed to shuffle board",
        {
          tags: {
            level: G.lvl.lvlIndex + 1,
          },
        }
      );
      return game.time.events.add(1, this.deconstruct, this);
    } else if (attempts > 20) {
      addColor(candiesToShuffle);
    }
    shuffle(candiesToShuffle);
  } while ((this.matcher.checkPossibleMoves().length == 0)
    || (attempts < 20 && getMatchingCandies().length > 0));

  G.sfx.whoosh_short_1.play();

  animateToRigthPositions(candiesToShuffle);
  handlePossibleMatches();

  return;

  function ensureMatchIsPossible(candies) {
    var matchMap = createMatchMap(candies);
    var mostCommonEntry = Object.entries(matchMap)
      .reduce(function (acc, entry) {
        return acc[1] > entry[1] ? acc : entry;
      });
    for (var i = mostCommonEntry[1]; i < 3; i++) {
      var candy = candies.find(function (candy) {
        return candy.getMatchToken() !== mostCommonEntry[0];
      });
      candy.import(mostCommonEntry[0]);
    }
  }

  function createMatchMap(candies) {
    var matchMap = {};
    candies.forEach(function (candy) {
      var matchToken = candy.getMatchToken();
      if (!matchMap[matchToken]) {
        matchMap[matchToken] = 0;
      }
      matchMap[matchToken]++;
    });
    return matchMap;
  }

  function addColor(candies) {
    var tokenToChangeInto = "1"
    var candyToChange = candies
      .find((candy) => {
        return candy.getMatchToken() !== tokenToChangeInto;
      });
    if (candyToChange) {
      candyToChange.init(
        candyToChange.cellX,
        candyToChange.cellY,
        tokenToChangeInto);
    } else {
      attempts = Infinity;
    }
  }

  function animateToRigthPositions(candies) {
    if (!immediate && !G.IMMEDIATE) {
      candies.forEach(function (candy) {
        candy.shuffleMoveToOwnCell();
      });
    }
  }

  function getCandiesToShuffle() {
    var candies = [];
    self.boardCandies.grid.loop(function (elem, x, y) {
      if (elem
        && self.isMoveable(x, y)
        && self.isCellMatchable(x, y)
        && !elem.isGoalCandy()
        && !elem.isBurntCandy()
        && elem.isShuffleable()) {
        candies.push(elem);
      }
    });
    return candies;
  }

  function shuffle(candiesToShuffle) {
    var shuffledArray = Phaser.ArrayUtils.shuffle(candiesToShuffle.slice());

    candiesToShuffle.forEach(function (candy, i) {
      var candyToSwapWith = shuffledArray[i];
      if (candy !== candyToSwapWith) {
        if (immediate || G.IMMEDIATE) {
          self.swapCandiesWithPosition(candy, candyToSwapWith);
        } else {
          self.swapCandies(candy, candyToSwapWith);
        }
      }
    });
  }

  function handlePossibleMatches() {
    var matches = getMatchingCandies();
    if (matches.length > 0) {
      self.checkMatchList = matches;
      self.actionManager.newAction("processMatch");
    }
  }

  function getMatchingCandies() {
    var result = [];
    self.boardCandies.grid.loop(function (elem, x, y) {
      if (!elem) return;
      if (!self.isCellMatchable(x, y)) return;
      if (self.matcher.quickMatchCheck(elem)) {
        result.push(elem);
      }
    });
    return result;
  }
};

G.Board.prototype.swapCandiesWithPosition = function (c1, c2) {

  this.boardCandies.grid.set(c1.cellX, c1.cellY, c2);
  this.boardCandies.grid.set(c2.cellX, c2.cellY, c1);

  var tmpCellX = c1.cellX;
  var tmpCellY = c1.cellY;
  var tmpX = c1.x;
  var tmpY = c1.y;

  c1.x = c2.x;
  c1.y = c2.y;
  c1.cellX = c2.cellX;
  c1.cellY = c2.cellY;

  c2.x = tmpX;
  c2.y = tmpY;
  c2.cellX = tmpCellX;
  c2.cellY = tmpCellY;

};

G.Board.prototype.deconstruct = function () {

  this.deconstructing = true;


  this.background.x += this.background.width * 0.5;
  this.background.y += this.background.height * 0.5;
  this.background.anchor.setTo(0.5);

  this.inputController.stopTweens();

  this.glowImg = G.makeImage(0, 0, 'popup_lighht', 0.5, this);
  this.glowImg.x = this.background.x;
  this.glowImg.y = this.background.y;
  this.glowImg.blendMode = 1;
  game.add.tween(this.glowImg).to({ angle: 360 }, 6000, Phaser.Easing.Linear.None, true);
  this.glowImg.alpha = 0;
  this.wellDoneTxt = game.add.image(0, 0, 'shoutouts', 'well_done');
  this.wellDoneTxt.anchor.setTo(0.5);
  this.add(this.wellDoneTxt);
  this.wellDoneTxt.x = this.background.x;
  this.wellDoneTxt.y = this.background.y;
  this.wellDoneTxt.visible = false;


  game.add.tween(this.boardDirt).to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In, true);
  game.add.tween(this.boardIce).to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In, true);
  game.add.tween(this.boardCage).to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In, true);
  game.add.tween(this.boardDirtS).to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In, true);
  game.add.tween(this.boardJam).to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In, true);

  game.time.events.add(200, this.boardCandies.deconstruct, this.boardCandies);

  game.time.events.add(900, function () {

    game.add.tween(this.background.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Sinusoidal.InOut, true);
    game.add.tween(this.background).to({ angle: 70 }, 500, Phaser.Easing.Sinusoidal.InOut, true);
  }, this)

  game.time.events.add(900, function () {
    game.add.tween(this.glowImg).to({ alpha: 0.2 }, 300, Phaser.Easing.Sinusoidal.Out, true);
    this.wellDoneTxt.visible = true;
    this.wellDoneTxt.scale.setTo(0);
    game.add.tween(this.wellDoneTxt.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Elastic.Out, true);
    G.sfx['shoutout_en_well_done'].play();
  }, this);

  game.time.events.add(2200, function () {
    game.add.tween(this.glowImg).to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true);
    game.add.tween(this.wellDoneTxt).to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true);
    this.onBoardDeconstructed.dispatch();
  }, this);

}